<div *ngIf="trade.fill.liquiditySource" class="text-gray-500 w-[200px]">
  {{ trade.fill.liquiditySource.readableName }}
  <div *ngIf="trade.fill.subFills.length === 1" class="text-gray-500">
    <ng-icon name="hero-arrow-turn-down-right-mini"></ng-icon>
    <span class="ml-1 text-gray-500"
      >100% {{ trade.fill.subFills[0].liquiditySource.readableName }}</span
    >
  </div>
  <div
    *ngIf="trade.fill.subFills.length > 1"
    (click)="openSankeyModal()"
    class="text-gray-500 hover:underline cursor-pointer"
  >
    <ng-icon name="hero-arrow-turn-down-right-mini"></ng-icon>
    <span class="ml-1 text-gray-500"
      >{{ trade.fill.subFills.length }} sub sources</span
    >
  </div>
</div>

<common-rebalancing-trade-fills-sankey-modal
  [(isOpen)]="isSankeyModalOpen"
  [trade]="trade"
></common-rebalancing-trade-fills-sankey-modal>
